(function () {
  if (window.__mimpactInit) return;
  window.__mimpactInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Split "1,500+" into prefix, numeric target, decimals and suffix.
  function parse(str) {
    var m = String(str).match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m) return null;
    var core = m[2];
    var decimals = (core.split('.')[1] || '').length;
    return {
      prefix: m[1],
      target: parseFloat(core.replace(/,/g, '')),
      decimals: decimals,
      suffix: m[3]
    };
  }

  function format(n, decimals) {
    return n.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function render(el, p, n) {
    el.textContent = p.prefix + format(n, p.decimals) + p.suffix;
  }

  function animate(el) {
    var p = parse(el.getAttribute('data-value'));
    if (!p) return;

    if (reduce) {
      render(el, p, p.target);
      return;
    }

    var duration = 1600;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      render(el, p, p.target * eased);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        render(el, p, p.target);
      }
    }

    render(el, p, 0);
    requestAnimationFrame(step);
  }

  var els = document.querySelectorAll('.mimpact__value[data-value]');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(animate);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();
